export default "__VITE_ASSET__RRyDyL2b__"